// login.js
import React, { useState } from "react";
import "./login.css";
import { useAuth } from "../contexts/authContext";

const LoginModal = ({ isOpen, onClose }) => {
  const { login, loading, authError } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [codFiscal, setCodFiscal] = useState("");

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await login({ email, password, codFiscal });
    if (res.success) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2>Login</h2>

        <form onSubmit={handleSubmit} className="inputs-container">
          <div className="input-group">
            <span className="input-label">Email</span>
            <input
              type="email"
              className="modern-input"
              placeholder="ex: user@domeniu.ro"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <span className="input-label">Parolă</span>
            <input
              type="password"
              className="modern-input"
              placeholder="Parola"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <span className="input-label">Cod fiscal</span>
            <input
              type="text"
              className="modern-input"
              placeholder="999999999"
              value={codFiscal}
              onChange={(e) => setCodFiscal(e.target.value)}
              required
            />
          </div>

          {authError && (
            <p style={{ color: "#fca5a5", fontSize: "0.8rem", marginTop: 2 }}>
              {authError}
            </p>
          )}

          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? "Se autentifică..." : "Login"}
          </button>
        </form>

        <button className="close-btn" onClick={onClose}>
          ✖
        </button>
      </div>
    </div>
  );
};

export default LoginModal;
